<template>
  <div class="mod-sys__organization">
    <!-- 查询条件：组织类型 公司名称(模糊) 状态 所在城市 公司编号(公司编号、BBA、NSO) 全称 开业时间(起止时间) 品牌 所属集团 -->
    <el-card shadow="never" class="aui-card--fill">
      <el-form label-position="top" :inline="true" :model="dataForm" @keyup.enter.native="getDataListMerge()">
        <el-row>
          <!-- 组织类型 -->
          <el-col :span="5">
            <el-form-item :label="$t('organization.orgType')">
              <el-select
                v-model="dataForm.orgType"
                :placeholder="$t('organization.orgType')"
                @change="getDataListMerge()"
                clearable>
                <el-option
                  v-for="(item,index) in typeArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 公司名称(模糊) -->
          <el-col :span="5">
            <el-form-item :label="$t('organization.abbreviation')">
              <el-input
                v-model="dataForm.abbreviation"
                type="text"
                :placeholder="$t('organization.abbreviation')"
                clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 状态 -->
          <el-col :span="5">
            <el-form-item :label="$t('organization.status')">
              <el-select v-model="dataForm.status" :placeholder="$t('organization.status')" clearable>
                <el-option
                  v-for="(item,index) in statusArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所在城市 -->
          <el-col :span="5">
            <el-form-item :label="$t('organization.cityIds')">
              <address-select
                      :level="4"
                      v-model="dataForm.regionIds"
                      :placeholder="$t('organization.cityIds')">
              </address-select>
            </el-form-item>
          </el-col>
          <el-button class="M-search" @click="getDataListMerge()" type="primary">{{ $t('query') }}</el-button>
          <el-button class="el-back M-search M-margin-l" type="info" @click="reset()">{{ $t('reset') }}</el-button>
        </el-row>
        <div v-show="isShow">
          <el-row>
            <!-- 公司编号(公司编号、BBA、NSO) -->
            <el-col :span="5">
              <el-form-item :label="$t('organization.orgCode')">
                <el-input
                  v-model="dataForm.orgCode"
                  type="text"
                  :placeholder="$t('organization.orgCode')"
                  clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 全称 -->
            <el-col :span="5">
              <el-form-item :label="$t('organization.name')">
                <el-input
                  v-model="dataForm.name"
                  type="text"
                  :placeholder="$t('organization.name')"
                  clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 品牌 -->
            <el-col :span="5">
              <el-form-item :label="$t('organization.brandCodes')">
                <el-select v-model="dataForm.brandCodes" :placeholder="$t('organization.brandCodes')" clearable>
                  <el-option
                          v-for="(item,index) in brandArr"
                          :key="index"
                          :label="item.name"
                          :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 所属集团 -->
            <el-col :span="5">
              <el-form-item :label="$t('organization.parentDealerGroupId')">
                <el-select
                        v-model="dataForm.parentDealerGroupId"
                        :placeholder="$t('organization.parentDealerGroupId')"
                        clearable
                        filterable>
                  <el-option
                          v-for="(item,index) in groupList"
                          :key="index"
                          :label="item.nameCn"
                          :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 开业时间起 -->
            <!-- <el-col :span="7">
              <el-form-item :label="$t('organization.openDateStart')">
                <el-date-picker
                  v-model="dataForm.openDateStart"
                  type="date"
                  :placeholder="$t('organization.openDateStart')">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <!-- 开业时间止 -->
            <!-- <el-col :span="7">
              <el-form-item :label="$t('organization.openDateEnd')">
                <el-date-picker
                  v-model="dataForm.openDateEnd"
                  type="date"
                  :placeholder="$t('organization.openDateEnd')">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col>
              <el-form-item :label="$t('organization.openDate')">
                <el-date-picker
                  v-model="dataForm.openDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="search">
        <el-button  plain class="el-button-columnBtn" @click="addUpdate()">{{ $t('add') }}</el-button>
        <el-button  plain class="el-button-columnBtn" @click="exportHandle()">{{ $t('export') }}</el-button>
      </div>
      <!-- 表头动态展示 orgType 10/40 20/30 50/60
      公司编号 中文名称 英文名称 公司简称 联系人 所在城市 状态
      公司编号 Vendor号 中文名称 英文名称 公司简称 联系人 所在城市 状态
      公司编号 NSC No BBA No 中文名称 英文名称 所在城市 是否主要网点 网点状态 网点类型 品牌 开业时间 -->
      <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
        <el-table-column
          prop="orgCode"
          align="center"
          fixed
          :label="$t('organization.orgCode')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50' || this.dataForm.orgType === '60'"
          prop="nscNo"
          align="center"
          :label="$t('organization.nscNo')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50' || this.dataForm.orgType === '60'"
          prop="bbaNo"
          align="center"
          :label="$t('organization.bbaNo')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '20' || this.dataForm.orgType === '30'"
          prop="venderNo"
          align="center"
          :label="$t('organization.venderNo')">
        </el-table-column>
        <el-table-column
          prop="nameCn"
          align="center"
          :label="$t('organization.nameZh')">
        </el-table-column>
        <el-table-column
          prop="nameEn"
          align="center"
          :label="$t('organization.nameEn')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType !== '50' && this.dataForm.orgType !== '60'"
          prop="abbreviationCn"
          align="center"
          :label="$t('organization.abbreviation')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType !== '50' && this.dataForm.orgType !== '60'"
          prop="contacterCn"
          align="center"
          :label="$t('organization.contacter')">
        </el-table-column>
        <el-table-column
          prop="regionIds"
          align="center"
          :formatter="cityFormatter"
          :label="$t('organization.cityIds')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType !== '50' && this.dataForm.orgType !== '60'"
          prop="status"
          align="center"
          :formatter="statusFormatter"
          :label="$t('organization.status')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '60'"
          prop="mainNetworkFlag"
          align="center"
          :formatter="confirmFormatter"
          :label="$t('organization.mainNetworkFlag')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50'"
          prop="dealerShipStatus"
          align="center"
          :formatter="dealerShipStatus"
          :label="$t('organization.dealerShipStatus')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '60'"
          prop="networkStatus"
          align="center"
          :formatter="networkStatus"
          :label="$t('organization.networkStatus')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50'"
          prop="dealerShipType"
          align="center"
          :formatter="dealerShipType"
          :label="$t('organization.dealerShipType')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '60'"
          prop="networkType"
          align="center"
          :formatter="networkType"
          :label="$t('organization.networkType')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50' || this.dataForm.orgType === '60'"
          prop="brandCodes"
          align="center"
          :formatter="brandFormatter"
          :label="$t('organization.brandCodes')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50'"
          prop="dealerSize"
          align="center"
          :label="$t('organization.dealerSize')">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '50'"
          prop="joinDateBmw"
          align="center"
          :label="$t('organization.joinDateBmw')"
          :formatter="joinDateBmwFormatter">
        </el-table-column>
        <el-table-column
          v-if="this.dataForm.orgType === '60'"
          prop="openDate"
          align="center"
          :label="$t('organization.openDate')"
          :formatter="openDateFormatter">
        </el-table-column>

        <el-table-column
          fixed="right"
          align="center"
          width="100"
          :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="gotoView('view', scope.row.orgId)">{{ $t('view') }}</el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('update', scope.row.orgId)">{{ $t('update') }}</el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('delete', scope.row)">{{ $t('delete') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddressSelect from '@/components/address-select'
import Vue from 'vue'
import ToggleDiv from '@/components/toggle-div'
import { getRegionNameList } from '@/utils'
export default {
  mixins: [mixinViewModule],
  data () {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/org/list',
        getDataListIsPage: true,
        deleteURL: '/sys/org/delete',
        exportURL: '/sys/org/export'
      },
      dataForm: {
        orgCode: '',
        orgType: '10',
        name: '',
        abbreviation: '',
        status: '',
        parentDealerGroupId: '',
        openDate: '',
        openDateStart: '',
        openDateEnd: '',
        regionIds: [],
        brandCodes: ''
      },
      typeArr: _this.enums['orgType'], // 组织类型
      statusArr: _this.enums['status'], // 状态
      brandArr: _this.enums['brandCode'], // 品牌
      groupList: [], // 所属集团
      dataList: [],
      dataListLoading: false,
      isShow: false
    }
  },
  components: {
    AddressSelect,
    ToggleDiv
  },
  methods: {
    getDataListMerge () {
      if (this.dataForm.openDate.length !== '') {
        if (this.dataForm.openDate.length === 2) {
          this.dataForm.openDateStart = this.dataForm.openDate[0]
          this.dataForm.openDateEnd = this.dataForm.openDate[1]
        }
      }
      this.dataForm.openDate = ''
      this.getDataList()
    },
    // 操作列下拉选项
    gotoView (type, id) {
      if (type === 'view') {
        this.$router.push({
          name: 'activiti-running-view',
          query: {
            taskId: 1,
            orgId: id,
            nameId: 3
          }
        })
      } else if (type === 'update') {
        this.$router.push({
          name: 'sys-organization-add-or-update',
          query: {
            orgId: id
          }
        })
      } else if (type === 'delete') {
        this.deleteOrg(id)
      }
    },
    // 删除
    deleteOrg (row) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$request.deleteAct(
          this.mixinViewModuleOptions.deleteURL,
          {
            orgId: row.orgId,
            parentOrgId: row.parentOrgId
          }
        ).then((res) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 展开更多
    toggle (data) {
      this.isShow = data
    },
    // 获取集团
    getGroup () {
      this.$request.get('/sys/org/selectDealerGroupByParam',
        {
          orgType: 40
        }
      ).then((res, total, code, data) => {
        this.groupList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    addUpdate (row) {
      this.$router.push({
        name: 'sys-organization-add-or-update',
        query: {
          orgId: row != null ? row.orgId : undefined
        }
      })
    },
    // 暂时不知道怎么传入自定义参数(即传入两个自定义参数——自定义标识位和列表中的值)，暂时弃用ele提供的回调方法
    handleCommand (command) {
      console.log(command)
    },
    orgTypeFormatter (row) {
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    confirmFormatter (row) {
      return Vue.filter('coverEnum')(row.mainNetworkFlag, 'confirmState')
    },
    dealerShipStatus (row) {
      return Vue.filter('coverEnum')(row.dealerShipStatus, 'openStatus')
    },
    networkStatus (row) {
      return Vue.filter('coverEnum')(row.dealerShipStatus, 'openStatus')
    },
    dealerShipType (row) {
      return Vue.filter('coverEnum')(row.dealerShipType, 'networkType')
    },
    networkType (row) {
      return Vue.filter('coverEnum')(row.networkType, 'networkType')
    },
    brandFormatter (row) {
      return Vue.filter('coverEnumList')(row.brandCodes, 'brandCode', ',')
    },
    // 城市格式返回
    cityFormatter (row) {
      return getRegionNameList(row.regionIds)
    },
    // 格式化时间没有时分秒
    joinDateBmwFormatter (row) {
      return Vue.filter('formatDateNoTime')(row.joinDateBmw)
    },
    openDateFormatter (row) {
      return Vue.filter('formatDateNoTime')(row.openDate)
    }
  },
  mounted () {
    this.getGroup()
  }
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 10px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.el-dropdown-menu {
  width: 100px;
  .el-dropdown-menu__item {
    text-align: center;
    color: #409EFF;
  }
}
</style>
